import { IAdsState } from '../../types/interfaces/states';
import { PauseAd } from '@shared/types/interfaces/ads';
import { RootState } from '../store';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: IAdsState = {
  lastImpression: undefined,
  pauseAd: undefined,
  impressionsUrls: [],
  source: undefined,
};

const adsSlice = createSlice({
  name: 'ads',
  initialState,
  reducers: {
    clearAds: (state) => {
      state.source = undefined;
    },
    clearPauseAd: (state) => {
      state.pauseAd = undefined;
    },
    setAds: (state, action: PayloadAction<string>) => {
      if (!state.source) {
        state.source = action.payload;
      }
    },
    setPauseAd: (state, action: PayloadAction<PauseAd>) => {
      state.pauseAd = action.payload;
    },
    setImpression: (state, action: PayloadAction<number>) => {
      state.lastImpression = action.payload;
    },
    setImpressionsUrls: (state, action: PayloadAction<string[]>) => {
      state.impressionsUrls = action.payload;
    },
    clearImpressionUrl: (state, action: PayloadAction<string>) => {
      const currentImpressionsUrls = state.impressionsUrls;
      const index = currentImpressionsUrls.indexOf(action.payload);
      if (index !== -1) {
        currentImpressionsUrls.splice(index, 1);
      }
      state.impressionsUrls = currentImpressionsUrls;
    }
  },
});

const { actions, reducer: adsReducer } = adsSlice;
export const { clearAds, clearPauseAd, setAds, setPauseAd, setImpression, setImpressionsUrls, clearImpressionUrl } =
  actions;
export const adsSelector = (state: RootState) => state.ads;
export default adsReducer;
